module.exports = __webpack_public_path__ + "img/icon-ecosystem-green.16889d69.svg";